class KpBestsellers extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-bs-track]');
    this.prevBtn = this.querySelector('[data-bs-prev]');
    this.nextBtn = this.querySelector('[data-bs-next]');
    this.progress = this.querySelector('[data-bs-progress]');
    this.thumb = this.querySelector('[data-bs-thumb]');
    if (!this.track) return;

    this.dragging = false;
    this.onScroll = () => {
      if (!this.dragging) this.sync();
    };
    this.onResize = () => this.sync();
    this.onPointerDown = (event) => this.startScrub(event);
    this.onPointerMove = (event) => this.moveScrub(event);
    this.onPointerUp = (event) => this.endScrub(event);

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.prevBtn?.addEventListener('click', () => this.step(-1));
    this.nextBtn?.addEventListener('click', () => this.step(1));
    this.progress?.addEventListener('pointerdown', this.onPointerDown);

    this.sync();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.progress?.removeEventListener('pointerdown', this.onPointerDown);
    this.unbindScrub();
  }

  cardStep() {
    const slide = this.track.querySelector('.kp-bs__slide');
    if (!slide) return this.track.clientWidth * 0.7;
    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  maxScroll() {
    return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
  }

  step(direction) {
    this.track.scrollBy({ left: direction * this.cardStep(), behavior: 'smooth' });
  }

  scrubMetrics() {
    const bar = this.progress.getBoundingClientRect();
    const max = this.maxScroll();
    const trackWidth = this.track.scrollWidth || 1;
    const view = this.track.clientWidth || 1;
    const thumbRatio = Math.min(1, view / trackWidth);
    return { bar, max, thumbRatio };
  }

  startScrub(event) {
    if (event.button != null && event.button !== 0) return;
    event.preventDefault();
    this.dragging = true;
    this.track.style.scrollBehavior = 'auto';
    this.track.style.scrollSnapType = 'none';
    this.progress.classList.add('is-dragging');
    this.progress.setPointerCapture?.(event.pointerId);
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
    window.addEventListener('pointercancel', this.onPointerUp);
    this.scrubTo(event);
  }

  moveScrub(event) {
    if (!this.dragging) return;
    this.scrubTo(event);
  }

  endScrub(event) {
    if (!this.dragging) return;
    this.dragging = false;
    this.track.style.scrollBehavior = '';
    this.track.style.scrollSnapType = '';
    this.progress.classList.remove('is-dragging');
    if (event?.pointerId != null) this.progress.releasePointerCapture?.(event.pointerId);
    this.unbindScrub();
    this.sync();
  }

  unbindScrub() {
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
    window.removeEventListener('pointercancel', this.onPointerUp);
  }

  scrubTo(event) {
    const { bar, max, thumbRatio } = this.scrubMetrics();
    if (max < 8 || bar.width <= 0) return;
    const usable = bar.width * (1 - thumbRatio);
    const x = event.clientX - bar.left - (bar.width * thumbRatio) / 2;
    const ratio = usable > 0 ? Math.min(1, Math.max(0, x / usable)) : 0;
    this.track.scrollLeft = ratio * max;
    this.sync();
  }

  sync() {
    const max = this.maxScroll();
    const atStart = this.track.scrollLeft <= 8;
    const atEnd = this.track.scrollLeft >= max - 8;
    this.prevBtn?.toggleAttribute('hidden', atStart || max < 8);
    this.nextBtn?.toggleAttribute('hidden', atEnd || max < 8);

    if (!this.thumb) return;
    const trackWidth = this.track.scrollWidth || 1;
    const view = this.track.clientWidth || 1;
    const thumbRatio = Math.min(1, view / trackWidth);
    const travel = 1 - thumbRatio;
    const progress = max > 0 ? this.track.scrollLeft / max : 0;
    this.thumb.style.width = `${thumbRatio * 100}%`;
    this.thumb.style.left = `${progress * travel * 100}%`;
  }
}

if (!customElements.get('kp-bestsellers')) {
  customElements.define('kp-bestsellers', KpBestsellers);
}
